const CardNumbers = ({ title, number, type, students = [] }) => {
    const studentNames = students.map(s => `${s.firstName} ${s.lastName}`).join('\n');

    return (
        <div className="dashboard__card-numbers">
            <div className="dashboard__card-num">
                <div className="dashboard__card-mini-title">{title}</div>
                <div className={`dashboard__card-info dashboard__card-info--${type}`}  title={studentNames}>
                    <span
                        className="num purecounter"
                        data-purecounter-start={0}
                        data-purecounter-end={number}
                        data-purecounter-duration={1}
                    >
                    </span>
                </div>
            </div>
        </div>
    );
};

export default CardNumbers;